import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

/**
 * Redux store configuration.
 * Redux Toolkit includes redux-thunk and devTools by default.
 */
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});
